export default __webpack_public_path__ + "static/media/le_touquet7.a38516d7.jpg";